module.exports = __webpack_public_path__ + "img/ch09_05_樱花柄高跟鞋.502fc8d4.jpg";